

export const quiz =  {

  "appLocale": {
  "landingHeaderText": "React Assessment (<questionLength> Questions)",
  "question": "Question",
  "startQuizBtn": "Start Assessment",
  "resultFilterAll": "All",
  "resultFilterCorrect": "Correct",
  "resultFilterIncorrect": "Incorrect",
  "prevQuestionBtn": "Prev",
  "nextQuestionBtn": "Next",
  "resultPageHeaderText": "You have completed the assessment. You got <correctIndexLength> out of <questionLength> questions."
},

  "quizTitle": "React JS",
  "quizSynopsis": "This assessment is designed to evaluate your understanding of knowledge and comprehension of React.js concepts, including its core principles, components, state management, JSX syntax, hooks, and other related topics.  If you have previously taken this assessment, your previous score will be replaced with your recent score. Before you begin please ensure you have access to a stable internet connection.",
  "nrOfQuestions": "50",
  "questions": [
    {
      "question": "What is the correct command to create a new React project?",
      "questionType": "text",
      // "questionPic": "https://codefussion.tech/elearning/assets/quiz-images/html.png", // if you need to display Picture in Question
      "answerSelectionType": "single",
      "answers": [
        "npx create-react-app",
        "npm create-react-app",
        "npx create-react-app myApp",
        "yarn start"
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "npx create-react-app myApp",
      "point": "5"
    },
    {
      "question": "What is the default local host port that a React development server uses?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "4000",
        "3000",
        "3500",
        "1000"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "3000",
      "point": "5"
    },
    {
      "question": "In React.js which one of the following is used to create a class for Inheritance?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Extends",
        "Create",
        "Inherits",
        "Export"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Extends",
      "point": "5"
    },
    {
      "question": "Which of the following is a way to handle data in React.js?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "State & Services",
        "State & Component",
        "State & Props",
        "None of the above",
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "State & Props",
      "point": "5"
    },
    {
      "question": "In React.js, how we can pass the data from one component to another in React.js?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Render",
        "Props",
        "setState",
        "PropTypes",
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Props",
      "point": "5"
    },
    {
      "question": "To develop and run React code, Node.js is required.",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "TRUE",
        "FALSE"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "TRUE",
      "point": "1"
    },
    {
      "question": "How would you create a constant in JavaScript?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "const",
        "let",
        'constant',
        "var",
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'const',
      "point": "5"
    },
    {
      "question": "React component names must begin with an uppercase letter",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "FALSE",
        "TRUE"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'TRUE',
      "point": "5"
    },

    // {
    //   "question": "which of the following is the correct way to insert an image",
    //   "questionType": "photo",
    //   "answerSelectionType": "single",
    //   "answers": [
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-1.png",
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-2.png",
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-3.png",
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-4.png"
    //   ],
    //   "correctAnswer": "4",
    //   "messageForCorrectAnswer": "Correct answer. Good job.",
    //   "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
    //   "explanation": "The image tag uses the src attribute and is a self-closing tag",
    //   "point": "5"
    // },
    {
      "question": "Which of the following is true regarding Babel?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "Transpiler",
        "Compiler",
        "Interpreter",
        "None of the above"
      ],
      "correctAnswer": [1, 2],
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Selected statements are true",
      "point": "5"
    },
    {
      "question": "Which of the following is used to render class components in web pages?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "transfer()",
        "Dom_render()",
        "render()",
        "return()",
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'render()',
      "point": "5"
    },
    {
      "question": "What is the best definition of React.js?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'A library for building user interfaces',
        'User-interface library',
        'Server-side Framework',
        'None of the above',
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation":'A library for building user interfaces',
      "point": "5"
    },
    {
      "question": "Which operator can be used to conditionally render a React component?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '||',
        '::',
        '??',
        '&&',
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '&&',
      "point": "5"
    },
    {
      "question": "What tool does React use to compile JSX?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'ReactDOM',
        'Babel',
        'React Router',
        'JSX Compiler',
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Babel',
      "point": "5"
    },
    {
      "question": "Which of the following statements about React Hooks is true?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "React Hooks were officially introduced in React 16.8",
        "useState is part of React Hooks",
        "React Hooks work with Class Components",
        "React Hooks work with Function Components"
      ],
      "correctAnswer": [1, 2, 4],
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Selected statements are true",
      "point": "5"
    },
    {
      "question": "What is a common use case for ref?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'To refer to a function',
        'To bind a function',
        'To refer another React file',
        'To access DOM elements',
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'To access DOM elements',
      "point": "5"
    },
    {
      "question": "Which below function in React.js is used to get the DOM node when the component is rendered?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'renderDom()',
        'getDomNode()',
        'findDomNode()',
        'componentAtNode()',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'The findDOMNode() function in React.js is used to get the DOM node when the component is rendered. It takes a single parameter as a component.',
      "point": "5"
    },
    {
      "question": "What is the correct syntax to import a Component from React?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'import [Component] from React',
        "import {Component} from 'react'",
        'import Component from React',
        "import {Component} from 'React'",
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "import {Component} from 'react' ",
      "point": "5"
    },
    {
      "question": "Find the bug in this code: <pre>function car({make, model}) {render( &lt;h1&gt{make} {model}&lt/h1&gt;)};</pre>",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'The first letter of Function should be capitalized',
        'Replace render with return',
        'There is no div tag',
        'This is not a React code',
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Replace render with return',
      "point": "5"
    },
    {
      "question": "Which is the right way of accessing a function showData() from an p element in JSX?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<p>{showData()}</p>',
        '<p>{showData}</p>',
        '<p>{$showData()}</p>',
        '<p>$showData</p>',
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<p>{showData()}</p>',
      "point": "5"
    },
    {
      "question": "Although React Hooks generally replace class components, there are no plans to remove classes from React.",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'TRUE',
        'FALSE'
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'TRUE',
      "point": "5"
    },
    {
      "question": "What is the purpose of the 'key' prop in a React list?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'For styling',
        'To enhance performance',
        'To trigger events',
        'To identify each element uniquely',
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'To identify each element uniquely',
      "point": "5"
    },
    {
      "question": "What does 'PureComponent' do in React?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Prevents re-rendering if props and state have not changed',
        'Manages pure functions',
        'Cleans up the component',
        'Enhances component performance',
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Prevents re-rendering if props and state have not changed',
      "point": "5"
    },
    {
      "question": "How do you optimize performance for a list of items in React that are frequently re-rendered?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Using shouldComponentUpdate',
        'Using useEffect',
        'Using useState',
        'Using React.memo',
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Using React.memo',
      "point": "5"
    },
    {
      "question": "Which of the following statements about <strong>useState</strong> is true?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "useState is used for both Function and Class components",
        "useState is used for only Function components",
        "To use useState you have to import it from the 'react' library",
        "All of the above"
      ],
      "correctAnswer": [2, 3],
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Selected statements are true",
      "point": "5"
    },
    {
      "question": "What is the primary use of the React Router library?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Handling forms',
        'Managing state',
        'Routing and navigation',
        'Optimizing performance',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'React Router library is used for Routing and Navigation',
      "point": "5"
    },
    {
      "question": "User interface developed with React is made of small and isolated pieces of code called?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Component',
        'Function',
        'Hook',
        'Snippet',
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Component',
      "point": "5"
    },
    {
      "question": "How many kinds of components does react have?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '5',
        '4',
        '2',
        '1'
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'React has two types of components Class based and functional',
      "point": "5"
    },
    {
      "question": "To write HTML in React we make use of?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'JSX',
        'XML',
        'HTTP',
        'Component',
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'JSX',
      "point": "5"
    },
    {
      "question": "React DOM uses what type of case property for naming?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Snake',
        'Pascal',
        'Camel',
        'Kebab',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Camel',
      "point": "5"
    },
    {
      "question": "React component can be rendered from other component?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'FALSE',
        'TRUE',
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'TRUE',
      "point": "5"
    },
    {
  "question": "What is the purpose of useEffect hook?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "To handle state management",
    "To perform side effects in function components",
    "To create context providers",
    "To optimize performance"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "useEffect is used for side effects like data fetching, subscriptions, etc.",
  "point": "5"
},
{
  "question": "Which method is called when a component is first mounted?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "componentWillMount",
    "componentDidMount",
    "componentMounted",
    "onMount"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "componentDidMount is called after the component is rendered to the DOM.",
  "point": "5"
},
{
  "question": "What is JSX?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "A JavaScript framework",
    "A syntax extension for JavaScript",
    "A templating language",
    "A CSS preprocessor"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "JSX is a syntax extension that allows writing HTML-like code in JavaScript.",
  "point": "5"
},
{
  "question": "Which of the following are React hooks?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": [
    "useState",
    "useEffect",
    "useContext",
    "useComponent"
  ],
  "correctAnswer": [1, 2, 3],
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "useState, useEffect, and useContext are built-in React hooks.",
  "point": "5"
},
{
  "question": "What is the purpose of useCallback hook?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "To handle API calls",
    "To memoize functions",
    "To create callback functions",
    "To manage state"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "useCallback memoizes functions to prevent unnecessary re-renders.",
  "point": "5"
},
{
  "question": "How do you pass data from child to parent component?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "Using props",
    "Using state",
    "Using callback functions",
    "Using context"
  ],
  "correctAnswer": "3",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "Parent components can pass callback functions as props to children.",
  "point": "5"
},
{
  "question": "What is React Context used for?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "To handle routing",
    "To manage global state without prop drilling",
    "To create components",
    "To optimize performance"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "Context provides a way to pass data through the component tree without prop drilling.",
  "point": "5"
},
{
  "question": "Which hook is used for performance optimization?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "useMemo",
    "useOptimize",
    "usePerformance",
    "useEffect"
  ],
  "correctAnswer": "1",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "useMemo memoizes expensive calculations to optimize performance.",
  "point": "5"
},
{
  "question": "What is the virtual DOM?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "A lightweight copy of the real DOM",
    "A database for React",
    "A browser feature",
    "A JavaScript framework"
  ],
  "correctAnswer": "1",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "Virtual DOM is a programming concept where a virtual representation of UI is kept in memory.",
  "point": "5"
},
{
  "question": "Which of the following are valid ways to handle events in React?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": [
    "onClick",
    "onChange",
    "onSubmit",
    "onHover"
  ],
  "correctAnswer": [1, 2, 3],
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "onClick, onChange, and onSubmit are valid React events.",
  "point": "5"
},
{
  "question": "What is the purpose of useReducer hook?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "To handle API requests",
    "To manage complex state logic",
    "To reduce component size",
    "To optimize rendering"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "useReducer is usually preferable to useState when you have complex state logic.",
  "point": "5"
},
{
  "question": "How can you conditionally apply CSS classes in React?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "Using template literals",
    "Using the classNames package",
    "Using conditional operators in className",
    "All of the above"
  ],
  "correctAnswer": "4",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "All these methods can be used for conditional CSS classes.",
  "point": "5"
},
{
  "question": "What is the purpose of React.Fragment?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "To create document fragments",
    "To group multiple elements without adding extra nodes",
    "To split components",
    "To improve performance"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "Fragments let you group elements without adding extra DOM nodes.",
  "point": "5"
},
{
  "question": "Which method is used to update state in class components?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "this.updateState()",
    "this.setState()",
    "this.modifyState()",
    "this.changeState()"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "setState() is used to update state in class components.",
  "point": "5"
},
{
  "question": "What is the purpose of PropTypes?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "To define component types",
    "To validate props passed to components",
    "To create property types",
    "To type check JavaScript"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "PropTypes is used for type checking props in React components.",
  "point": "5"
},
{
  "question": "Which of the following are popular state management libraries for React?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": [
    "Redux",
    "MobX",
    "Zustand",
    "Vuex"
  ],
  "correctAnswer": [1, 2, 3],
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "Redux, MobX, and Zustand are React state management libraries.",
  "point": "5"
},
{
  "question": "What is the purpose of useRef hook?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "To create references to DOM elements",
    "To manage state references",
    "To reference other components",
    "To create refactoring tools"
  ],
  "correctAnswer": "1",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "useRef returns a mutable ref object whose .current property is initialized to the passed argument.",
  "point": "5"
},
{
  "question": "What is the children prop?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "Props passed to child components",
    "The content between a component's opening and closing tags",
    "Props for rendering lists of children",
    "A special prop for nested components"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "The children prop contains the content between a component's opening and closing tags.",
  "point": "5"
},
{
  "question": "Which lifecycle method is called before a component is removed from DOM?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "componentWillUnmount",
    "componentDidUnmount",
    "componentRemove",
    "beforeUnmount"
  ],
  "correctAnswer": "1",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "componentWillUnmount is called right before a component is destroyed.",
  "point": "5"
},
{
  "question": "What is the purpose of React.StrictMode?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "To enable strict JavaScript mode",
    "To highlight potential problems in an application",
    "To enforce strict prop types",
    "To optimize performance"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct answer. Good job.",
  "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
  "explanation": "StrictMode activates additional checks and warnings for its descendants.",
  "point": "5"
}
  ]
}
